import { primary } from '../colors';
import palette from '../palette';

const muiFilledInputOverrides = {
  styleOverrides: {
    root: {
      backgroundColor: palette.background.default,
      '&:hover': {
        backgroundColor: primary.light,
      },
      '&$focused': {
        backgroundColor: primary.light,
      },
    },
  },
};

export default muiFilledInputOverrides;
